// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlianceTableSearchController from "./aliance_table_search_controller"
application.register("aliance-table-search", AlianceTableSearchController)

import AllianceTableSearchController from "./alliance_table_search_controller"
application.register("alliance-table-search", AllianceTableSearchController)

import GasStationTableSearchController from "./gas_station_table_search_controller"
application.register("gas-station-table-search", GasStationTableSearchController)

import AdminTableSearchController from "./admin_table_search_controller"
application.register("admin-table-search", AdminTableSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SelectizeController from "./selectize_controller"
application.register("selectize", SelectizeController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DateFilterController from "./date_filter_controller"
application.register("date-filter", DateFilterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)
